import React from 'react';

const Blog = () => {
    return (
        <div className='flex justify-center items-center'>
            <h1 className='text-5xl py-10 text-red-500 text-'>COMING SOON</h1>
        </div>
    );
};

export default Blog;